import Seo from "./Seo";
import { buildkalyanakalpataruDescription, buildkalyanakalpataruJsonLd, buildkalyanakalpataruKeywords } from "../utils/KalyankalpataruSeo";

type kalyanakalpataruSeoProps = {
  kalyanakalpataru: any;
  canonicalPath: string;
};

const kalyanakalpataruSeo = ({ kalyanakalpataru, canonicalPath }: kalyanakalpataruSeoProps) => {
    debugger;
  if (!kalyanakalpataru) return null;

  const title = kalyanakalpataru?.pageTitle || kalyanakalpataru?.ogTitle || (kalyanakalpataru?.name ? `${kalyanakalpataru.name} | Gita Seva` : "Gita Seva kalyanakalpataru");
  const description = kalyanakalpataru?.pageDescription || kalyanakalpataru?.ogDescription || buildkalyanakalpataruDescription(kalyanakalpataru);
  const keywords = buildkalyanakalpataruKeywords(kalyanakalpataru);
  const image = kalyanakalpataru?.ogImage || kalyanakalpataru?.kalyanakalpataruPath || "";
  const jsonLd = buildkalyanakalpataruJsonLd(kalyanakalpataru, canonicalPath);

  return (
    <Seo
      title={title}
      description={description}
      keywords={keywords}
      path={canonicalPath}
      image={image}
      ogImageWidth={1200}
      ogImageHeight={630}
      ogType="kalyanakalpataru"
      robots="index,follow"
      jsonLd={jsonLd}
    />
  );
};

export default kalyanakalpataruSeo;






